/**
 * Restructures Judge.me review items into the Berri two-column layout.
 */
(function () {
  const PROCESSED = 'data-berri-layout';

  function findDateRow(details) {
    if (!details) return null;

    const explicit = details.querySelector('[class*="date"], [class*="timestamp"], time');
    if (explicit) return explicit;

    const children = Array.from(details.children);
    if (children.length < 2) return null;

    return children[children.length - 1];
  }

  function updateVerifiedBadges() {
    document.querySelectorAll('.jm-reviewer-info [class*="verified"]').forEach((badge) => {
      const text = badge.textContent.trim();
      if (text === 'Verified' || text === 'verified') {
        badge.textContent = 'Verified Reviewer';
      }
    });
  }

  function layoutReviewItem(item) {
    if (item.hasAttribute(PROCESSED)) return;

    const content = item.querySelector('.jm-review-item__content');
    const reviewerInfo = item.querySelector('.jm-reviewer-info');
    const reviewContent = item.querySelector('.jm-review-content');

    if (!content || !reviewerInfo || !reviewContent) return;

    item.setAttribute(PROCESSED, 'true');

    const details = reviewerInfo.querySelector('.jm-reviewer-info__details');
    const dateRow = findDateRow(details);

    if (dateRow && dateRow.parentElement === details) {
      dateRow.classList.add('berri-review-layout__date');
    }

    const layout = document.createElement('div');
    layout.className = 'berri-review-layout';

    const sidebar = document.createElement('div');
    sidebar.className = 'berri-review-layout__sidebar';

    const main = document.createElement('div');
    main.className = 'berri-review-layout__content';

    const meta = document.createElement('div');
    meta.className = 'berri-review-layout__meta';
    if (dateRow) {
      meta.appendChild(dateRow);
    }

    /* Keep star rating cluster (jm-star-rating) in sidebar — was being removed on layout */
    Array.from(content.children).forEach((child) => {
      if (child === reviewerInfo || child === reviewContent) return;
      sidebar.appendChild(child);
    });

    sidebar.appendChild(reviewerInfo);
    main.appendChild(reviewContent);
    layout.appendChild(sidebar);
    layout.appendChild(main);
    layout.appendChild(meta);

    content.replaceChildren(layout);
  }

  function updateWriteReviewButtons() {
    document
      .querySelectorAll(
        '[data-testid="write-review-button"], .jm-action-buttons__button.jm-button--primary, .jm-action-buttons .jm-button--primary'
      )
      .forEach((btn) => {
        if (btn.closest('.jm-pagination-controls')) return;
        btn.classList.add('button', 'button--primary');
      });
  }

  function formatHeaderReviewCount(summaryCol) {
    summaryCol.querySelectorAll('.jm-text, span, p').forEach((el) => {
      if (el.children.length > 0) return;

      const text = el.textContent.trim();
      const reviewMatch = text.match(/^(\d[\d,]*)\s*reviews?$/i);

      if (reviewMatch) {
        el.textContent = `Based on ${reviewMatch[1]} reviews`;
        el.classList.add('berri-review-header__count');
        return;
      }

      if (/^\d+(\.\d+)?$/.test(text)) {
        el.classList.add('berri-review-header__score');
      }
    });
  }

  function findHeaderSummary(header, mainContent) {
    const explicit = header.querySelector(
      '.jm-review-widget-header__summary, .jm-review-widget-header__rating-summary, [class*="header__aggregate"]'
    );

    if (explicit) return explicit;

    return Array.from(header.children).find((child) => {
      if (child === mainContent) return false;
      if (child.classList.contains('jm-review-widget-header__title')) return false;
      if (child.classList.contains('jm-review-widget-header__filters-wrapper')) return false;
      if (child.classList.contains('berri-review-header-layout')) return false;

      return child.querySelector('.jm-star-rating, [class*="average"], [class*="review-count"]');
    });
  }

  function orderRatingBlock(block) {
    const items = Array.from(block.children);
    const score = items.find(
      (el) =>
        el.classList.contains('berri-review-header__score') ||
        (/^\d+(\.\d+)?$/.test(el.textContent.trim()) && !el.querySelector('.jm-star-rating'))
    );
    const stars = items.find(
      (el) => el.classList.contains('jm-star-rating') || el.querySelector('.jm-star-rating')
    );
    const count = items.find(
      (el) =>
        el.classList.contains('berri-review-header__count') ||
        /based on|reviews?/i.test(el.textContent.trim())
    );

    block.replaceChildren();
    [score, stars, count].forEach((el) => {
      if (el) block.appendChild(el);
    });

    items.forEach((el) => {
      if (!block.contains(el)) block.appendChild(el);
    });
  }

  function buildRatingBlock(summarySource) {
    const block = document.createElement('div');
    block.className = 'berri-review-header__rating-block';

    if (!summarySource) return block;

    const stars = summarySource.querySelector('.jm-star-rating');
    if (stars) block.appendChild(stars);

    summarySource.querySelectorAll('.jm-text, span, p').forEach((el) => {
      if (el.classList.contains('jm-review-widget-header__title')) return;
      if (el.closest('.jm-review-widget-header__title')) return;
      if (el.children.length > 0) return;
      if (stars && stars.contains(el)) return;

      const text = el.textContent.trim();
      if (!text) return;

      if (/^\d+(\.\d+)?$/.test(text) || /reviews?/i.test(text) || /based on/i.test(text)) {
        block.appendChild(el);
      }
    });

    if (!block.children.length) {
      const titleAndRating =
        summarySource.querySelector('.jm-review-widget-header__title-and-rating') || summarySource;

      Array.from(titleAndRating.children).forEach((child) => {
        if (!child.classList.contains('jm-review-widget-header__title')) {
          block.appendChild(child);
        }
      });
    }

    formatHeaderReviewCount(block);
    orderRatingBlock(block);

    return block;
  }

  function layoutReviewHeader() {
    document.querySelectorAll('.jm-review-widget-header').forEach((header) => {
      if (header.getAttribute('data-berri-header-layout') === '2') return;

      const mainContent = header.querySelector('.jm-review-widget-header__main-content');
      if (!mainContent) return;

      const histogram = mainContent.querySelector(
        '.jm-histogram, .jm-review-widget-header__star-rating-histogram'
      );
      const actions = mainContent.querySelector('.jm-action-buttons');
      if (!histogram || !actions) return;

      const title = header.querySelector('.jm-review-widget-header__title');
      if (title && mainContent.parentElement) {
        header.insertBefore(title, mainContent);
      }

      let summarySource =
        header.querySelector('.jm-review-widget-header__summary-section') ||
        mainContent.querySelector('.jm-review-widget-header__summary-section') ||
        mainContent.querySelector('.berri-review-header-layout__summary > *') ||
        findHeaderSummary(header, mainContent);

      const layout = document.createElement('div');
      layout.className = 'berri-review-header-layout';

      const summaryCol = document.createElement('div');
      summaryCol.className = 'berri-review-header-layout__summary';
      summaryCol.appendChild(buildRatingBlock(summarySource));

      const histogramCol = document.createElement('div');
      histogramCol.className = 'berri-review-header-layout__histogram';

      const actionsCol = document.createElement('div');
      actionsCol.className = 'berri-review-header-layout__actions';

      histogramCol.appendChild(histogram);
      actionsCol.appendChild(actions);

      layout.appendChild(summaryCol);
      layout.appendChild(histogramCol);
      layout.appendChild(actionsCol);

      mainContent.replaceChildren(layout);

      header.querySelectorAll('.jm-review-widget-header__summary-section').forEach((section) => {
        if (!section.querySelector('.jm-star-rating, .jm-text, .berri-review-header__score')) {
          section.remove();
        }
      });

      header.setAttribute('data-berri-header-layout', '2');
    });
  }

  function layoutAllReviews() {
    layoutReviewHeader();
    document.querySelectorAll('.jm-review-item').forEach(layoutReviewItem);
    updateVerifiedBadges();
    updateWriteReviewButtons();
  }

  function init() {
    layoutAllReviews();

    const observer = new MutationObserver(() => {
      layoutAllReviews();
    });

    const widget = document.querySelector('.jm-review-widget, #judgeme_product_reviews');
    if (widget) {
      observer.observe(widget, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('judgeme:loaded', init);
})();
